import { KeyValue } from '@/main/models/common';

export enum SupplierInventoryImportStatusTypes {
  GET_SUPPLIER_INVENTORY_IMPORT_STATUS = '@supplierInventoryImportStatus/GET_SUPPLIER_INVENTORY_IMPORT_STATUS',
  SAVE_SUPPLIER_INVENTORY_IMPORT_STATUS = '@supplierInventoryImportStatus/SAVE_SUPPLIER_INVENTORY_IMPORT_STATUS',
  RESET_REDUCER_SUPPLIER_INVENTORY_IMPORT_STATUS = '@supplierInventoryImportStatus/RESET_REDUCER_SUPPLIER_INVENTORY_IMPORT_STATUS'
}

export interface SupplierInventoryImportStatusState {
  readonly supplierInventoryImportStatus: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetSupplierInventoryImportStatus {
  type: typeof SupplierInventoryImportStatusTypes.GET_SUPPLIER_INVENTORY_IMPORT_STATUS;
}

export interface SaveSupplierInventoryImportStatus {
  type: typeof SupplierInventoryImportStatusTypes.SAVE_SUPPLIER_INVENTORY_IMPORT_STATUS;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerSupplierInventoryImportStatus {
  type: typeof SupplierInventoryImportStatusTypes.RESET_REDUCER_SUPPLIER_INVENTORY_IMPORT_STATUS;
}

export type SupplierInventoryImportStatusActionTypes =
  | GetSupplierInventoryImportStatus
  | SaveSupplierInventoryImportStatus
  | ResetReducerSupplierInventoryImportStatus;
